import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNotificationFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.75 3.75a1.25 1.25 0 0 1 2.5 0v.87A6.5 6.5 0 0 1 18.5 11v6.5h1.25a.75.75 0 0 1 0 1.5H4.25a.75.75 0 0 1 0-1.5H5.5V11a6.5 6.5 0 0 1 5.25-6.38zM13.75 20a1.75 1.75 0 1 1-3.5 0zM20.558 9.608a.72.72 0 0 0 .573.154.69.69 0 0 0 .496-.314.73.73 0 0 0 .106-.591 9 9 0 0 0-1.327-3.087 9.5 9.5 0 0 0-2.266-2.363.85.85 0 0 0-.59-.143.62.62 0 0 0-.478.323.74.74 0 0 0-.085.585q.081.3.36.496a7.7 7.7 0 0 1 1.796 1.924 8 8 0 0 1 1.083 2.498.96.96 0 0 0 .332.518M2.867 9.734a.69.69 0 0 1-.496-.322.73.73 0 0 1-.096-.593 9.1 9.1 0 0 1 1.378-3.07A9.5 9.5 0 0 1 5.96 3.42a.82.82 0 0 1 .586-.129.63.63 0 0 1 .468.335q.16.286.083.582a.84.84 0 0 1-.357.488 7.8 7.8 0 0 0-1.832 1.898 8 8 0 0 0-1.129 2.484.96.96 0 0 1-.34.513.72.72 0 0 1-.571.144"
  }));
}
var IcNotificationFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotificationFill));

export { IcNotificationFill as I };
